export default "__VITE_ASSET__6302ba99__"